export default __webpack_public_path__ + "ae5b94ec408913624617b9f2d5af0351.png";